





























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  ScheduleCalendarHeaderDate, ScheduleCalendarMode, Schedule, TutorSchedule, ScheduleRequest
} from '@/modules/schedule';
import { Calendar,  } from '@/modules/calendar';
import ScheduleCalendar from '@/components/schedule/scheduleCalendar.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { Subject } from '@/models/subject';
import { Person } from '@/models/person';
import { SubmitArgs as StudentSelectedArgs } from '@/components/student/studentSelectDialog.vue';

@Component({
  components: {
    ScheduleCalendar,
  }
})
export default class extends AvaivaledVue {
  private ScheduleCalendarMode = ScheduleCalendarMode;
  private get isMini(): boolean { return (this as any).$mq === 'mini'; }
  private get pageTitle() {
    if (this.isTemporary) {
      return '予約カレンダー登録前確認';
    } else {
      return '予約カレンダー編集';
    }
  }
  private get headerIcon() { return 'far fa-calendar-alt fa-2x'; }
  private get isLoading() { return this.$store.state.calendar.isLoading; }

  private get calendarId(): number { return parseInt(this.$route.params.calendarId, 10); }
  private get calendar(): Calendar { return this.$store.state.calendar.info; }
  private get schedules(): TutorSchedule[] { return this.calendar.schedules; }

  private get isTemporary(): boolean { return this.calendar.isTemporary; }

  private headers: ScheduleCalendarHeaderDate[] = [];

  private headerTopDate = new Date();

  private studentSelectVisible = false;
  private selectSubjectVisible = false;
  private selectedSubject: Subject = { id: 0, name: '', color: '' };
  private selectedSubjectId = 0;
  private selectedStudents: Person[] = [];
  private addSchedule: Schedule = {
    scheduleId: 0,
    weekday: 0,
    unixtimeDate: null,
    stringStart: '',
    stringEnd: '',
    subjects: [],
    capacity: 0,
    reservers: [],
    memo: '',
  };

  private async loadData() {
    await this.$store.dispatch('calendar/getInfoRequest', this.calendarId);
    if (!this.calendar || (this.calendar.calendarId !== this.calendarId)) {
      this.$router.push('/schedule');
    }
  }

  private async mounted() {
    await this.loadData();

    this.headerTopDate = new Date(this.calendar.year, this.calendar.month - 1, 1, 0, 0, 0);
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  @Watch('headerTopDate')
  private onChangedheaderTopDate() {
    this.headers = [];
    for (let i = 0; i < 7; ++i) {
      const date = new Date(this.headerTopDate);
      date.setDate(this.headerTopDate.getDate() + i);
      this.headers.push({ date, weekday: date.getDay() });
    }
  }

  private clickArrowButton(num: number) {
    let date = this.headerTopDate.getDate() + num;
    const lastDate = new Date(this.headerTopDate.getFullYear(), this.headerTopDate.getMonth() + 1, 0).getDate() - 6;
    if (date <= 0) { date = 1; }
    if (date > lastDate) { date = lastDate; }

    this.headerTopDate.setDate(date);
    this.headerTopDate = new Date(this.headerTopDate);
  }

  private async createOrEditRequest(request: ScheduleRequest) {
    request.calendarId = this.calendarId;
    const response = await this.$store.dispatch(
      request.scheduleId ?
      'calendar/editScheduleRequest' :
      'calendar/createScheduleRequest', request);
    if (response && (response.status === 200 || response.status === 201)) {
      const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
        return request.tutorId === value.tutorId;
      });
      if (findTutorSchedule !== undefined) {
        this.$notify({
          type: 'success',
          title: 'スケジュール' + (request.scheduleId ? '編集' : '追加') + '完了',
          message:
            `講師「${findTutorSchedule.tutorName}」のスケジュールを` +
            (request.scheduleId ? '編集' : '追加') +
            'しました。',
          position: 'bottom-right'
        });
        this.loadData();
      }
    } else {
      this.$notify({
        type: 'error',
        title: 'スケジュール' + (request.scheduleId ? '編集' : '追加') + '失敗',
        message: response.message,
        position: 'bottom-right'
      });
    }
  }

  private async removeRequest(scheduleId: number) {
    const response = await this.$store.dispatch('calendar/removeScheduleRequest', {
      calendarId: this.calendarId,
      scheduleId
    })
      .catch(() => {
        const a = 1;
      });
    if (!response) { return; }

    const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
      return value.schedules.find((schedule: Schedule) => {
        return schedule.scheduleId === scheduleId;
      }) !== undefined;
    });
    if (findTutorSchedule) {
      this.$notify({
        type: 'success',
        title: 'スケジュール削除完了',
        message:
          `講師「${findTutorSchedule.tutorName}」のスケジュールを削除しました。`,
        position: 'bottom-right'
      });
      this.loadData();
    }
  }

  private async moveRequest(request: ScheduleRequest) {
    request.calendarId = this.calendarId;
    const response = await this.$store.dispatch(
      request.scheduleId ?
      'calendar/editScheduleRequest' :
      'calendar/createScheduleRequest', request);
    if (response && (response.status === 200 || response.status === 201)) {
      const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
        return request.tutorId === value.tutorId;
      });
      if (findTutorSchedule !== undefined) {
        this.$notify({
          type: 'success',
          title: 'スケジュール移動完了',
          message:
            `講師「${findTutorSchedule.tutorName}」のスケジュールを移動しました。`,
          position: 'bottom-right'
        });
        this.loadData();
      }
    } else {
      this.$notify({
        type: 'error',
        title: 'スケジュール移動失敗',
        message: response.message,
        position: 'bottom-right'
      });
    }
  }

  private async copyRequest(request: ScheduleRequest) {
    request.calendarId = this.calendarId;
    const response = await this.$store.dispatch('calendar/copyScheduleRequest', request);
    if (response && (response.status === 200 || response.status === 201)) {
      const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
        return request.tutorId === value.tutorId;
      });
      if (findTutorSchedule !== undefined) {
        this.$notify({
          type: 'success',
          title: 'スケジュールコピー完了',
          message:
            `講師「${findTutorSchedule.tutorName}」のスケジュールをコピーしました。`,
          position: 'bottom-right'
        });
        this.loadData();
      }
    } else {
      this.$notify({
        type: 'error',
        title: 'スケジュールコピー失敗',
        message: response.message,
        position: 'bottom-right'
      });
    }
  }

  private clickAddReserver(scheduleId: number) {
    let findSchedule: Schedule | undefined;
    this.schedules.find((value) => {
      findSchedule = value.schedules.find((value2) => {
        return value2.scheduleId === scheduleId;
      });
      return findSchedule !== undefined;
    });

    if (findSchedule !== undefined) {
      this.addSchedule = findSchedule;
      this.selectedStudents = JSON.parse(JSON.stringify((findSchedule as Schedule).reservers));
      this.selectedSubjectId = this.addSchedule.subjects[0].id;
      if ((findSchedule as Schedule).subjects.length === 1) {
        this.studentSelectVisible = true;
        this.selectedSubject = this.addSchedule.subjects[0];
      } else {
        this.selectSubjectVisible = true;
      }
    }
  }

  private addSubject() {
    this.studentSelectVisible = true;
    this.selectSubjectVisible = false;
  }

  private async onSubmitSelectedStudents(args: StudentSelectedArgs) {
    const before = this.selectedStudents;
    const after = JSON.parse(JSON.stringify(args.selectedStudents));

    const senderStudents: Person[] = [];
    after.forEach((val: Person) => {
      const isNew = before.find((val2: Person) => {
        return val2.id === val.id;
      }) === undefined;
      if (isNew) {
        senderStudents.push(val);
      }
    });

    if (senderStudents.length === 0) {
        this.$alert('生徒の選択がありませんでした', '', {
          type: 'error',
          confirmButtonText: 'OK',
        });
    } else {
      for (const student of senderStudents) {
        const response = await this.$store.dispatch('calendar/addReserver', {
          calendarId: this.calendarId,
          scheduleId: this.addSchedule.scheduleId,
          subjectId: this.selectedSubjectId,
          studentId: student.id,
        });
        if (response && (response.status === 201 || response.status === 200)) {
          this.$notify({
            type: 'success',
            title: '予約設定',
            message: '予約カレンダーに生徒の予約を行いました',
            position: 'bottom-right'
          });
        } else {
          this.$notify({
            type: 'error',
            title: '予約エラー',
            message: response.message,
            position: 'bottom-right'
          });
        }
      }
      this.$nextTick(() => {
        (this.$refs.scheduleCalendar as any).closeEditModal();
        this.loadData();
      });
    }
  }

  private onCancelSelectedStudents() {
    const a = 1;
  }

  private clickReserverName(reserverId: string, scheduleId: number) {
    this.$confirm('選択した生徒を予約カレンダーから削除します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    })
    .then(async () => {

      const response = await this.$store.dispatch('calendar/removeReserver', {
        scheduleId,
        studentId: reserverId,
      }).catch();
      if (response && (response.status === 201 || response.status === 200)) {
        this.$notify({
          type: 'success',
          title: '予約設定',
          message: '予約カレンダーから生徒の予約を削除しました',
          position: 'bottom-right'
        });
        (this.$refs.scheduleCalendar as any).closeEditModal();
        this.loadData();
      } else {
        this.$notify({
          type: 'error',
          title: '予約エラー',
          message: response.message,
          position: 'bottom-right'
        });
      }
    })
    .catch();
  }

  private onDelete() {
    this.$confirm('登録前の予約カレンダーを削除します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    })
    .then(async () => {
      const response = await this.$store.dispatch('calendar/removeRequest', this.calendarId)
        .catch(() => { const a = 1; });
      if (response) {
        this.$notify({
          type: 'success',
          title: '予約カレンダー削除完了',
          message: '登録前の予約カレンダーを削除しました。',
          position: 'bottom-right'
        });
        this.$router.push({
          name: 'Schedule',
        });
      }
    })
    .catch();
  }

  private onRegist() {
    this.$confirm('登録前の予約カレンダーを本登録します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    })
    .then(async () => {
      const response = await this.$store.dispatch('calendar/createRequest', this.calendarId)
        .catch(() => { const a = 1; });
      if (response) {
        this.$notify({
          type: 'success',
          title: '予約カレンダー登録完了',
          message: '予約カレンダーを登録しました。',
          position: 'bottom-right'
        });
        this.$router.push({
          name: 'Schedule',
        });
      }
    })
    .catch();
  }

}
